var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("iframe", {
    attrs: {
      width: "750",
      height: "400",
      frameborder: "0",
      src: _vm.iFrameSrc,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }